// extracted by mini-css-extract-plugin
export default {"header":"MyClientAllocations_header__DwUL7","tabsWrapper":"MyClientAllocations_tabsWrapper__8tP5x"};